import React from 'react';
import HeroSection from '../components/home/HeroSection';
import CategorySection from '../components/home/CategorySection';
import AboutSection from '../components/home/AboutSection';
import TestimonialSection from '../components/home/TestimonialSection';
import SEO from '../components/SEO';
import { useLanguage } from '@/i18n/LanguageProvider';

export default function Home() {
  const { t } = useLanguage();
  return (
    <>
      <SEO 
        title="Home"
        description={t('Bellomonte & Pensabene - Studio di architettura e interior design a Palermo. Progetti residenziali e commerciali innovativi con tecnologia VR immersiva.')}
        keywords="architettura Palermo, interior design, progettazione VR, studio architettura, design residenziale, design commerciale"
        image="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/696b8a6ae79eec44c999be35/51939c246_image-removebg-preview.png"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Bellomonte & Pensabene Studio di Architettura',
          url: 'https://studioarchitetturabellomontepensabene.it/'
        }}
      />
      <div>
        <HeroSection />
        <CategorySection />
        <AboutSection />
        <TestimonialSection />
      </div>
    </>
  );
}